import ToggleItem from './toggle_item';

export default class Underline extends ToggleItem {
  constructor() {
    super('underline', 'Ctrl+U');
  }
}
